import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import './style/Darkmode.css'
import App from './App.tsx'
import posthog from 'posthog-js'
import { PostHogProvider } from '@posthog/react'
import * as Sentry from '@sentry/react'
import { validateEnv } from './utils/validateEnv'

validateEnv()

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: import.meta.env.PROD,
  environment: import.meta.env.MODE,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.1,
  sendDefaultPii: true,
})

posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN, {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  ui_host: 'https://us.posthog.com',
  defaults: '2026-01-30',
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PostHogProvider client={posthog}>
      <BrowserRouter>
        <Sentry.ErrorBoundary fallback={<div>Something went wrong</div>}>
          <App />
        </Sentry.ErrorBoundary>
      </BrowserRouter>
    </PostHogProvider>
  </StrictMode>,
)
